import './App.css';
import {Route, Switch} from 'react-router-dom';
import invitationDetails from './containers/invitationDetails';
import Invite from './containers/invite';
import Collaboration from './containers/Collaboration/collaboration';
import CollaborationNetivim from './containers/CollaborationNetivim/collaborationNetivim';
import Agents from './containers/Agents/agents';
import Profile from './containers/Profile/Profile';
import Terms from './containers/Terms/Terms';
import contact from './containers/contact/contact';
//payment flow
import afterPayment from './containers/afterPayment/afterPayment';

import success from './containers/Success/success';
import paymentErorr from './containers/paymentErorr/paymentErorr';
//payment flow end
import myInvitation from './containers/myInvitation/myInvitation';
import notConfirmedYet from './containers/notConfirmedYet/notConfirmedYet';
import mySadirTravels from './containers/mySadirTravels/mySadirTravels';
import editSadir from './containers/editSadir/editSadir';
import editPrivate from './containers/editPrivate/editPrivate';
import comments from './containers/comments/comments';
import refund from './containers/refund/refund';
import airports from './containers/airports/airports';
import verifyInvite from './containers/verifyInvite/verifyInvite';
import verifyPassengers from './containers/VerifyPassengers/verifyPassengers';
import homePage from './containers/Home/homePage';
import priceList from './containers/PriceList/priceList';
import askOrbit from './containers/askOrbit/askOrbit';
import generateCard from './containers/generateCard/generateCard';
import byAgent from './containers/ByAgent/byAgent';
import topBaner from './containers/TopBaner/topBaner';
import footer from './containers/Footer/Footer';
import sideBar from './containers/SideBar/sideBar';
import numOfPayment from './containers/numOfPayment/numOfPayment';
import AfterPaymentSaveTravel from './containers/_after_payment_save_travel/_after_payment_save_travel';
import TimeCalc from './containers/contact/timeCalc/timeCalc';
import PayPerClick from './containers/invite/steps/summary/PayPerClick';
import AccessibilityStatement from './containers/AccessibilityStatement/accessibilityStatement' ; 
import PrivacyStatement from './containers/privacyStatement/privacyStatement'
import AccessibilityMenu from './containers/AccessibilityMenu/accessibilityMenu';

const App = () => {

  window.addEventListener('iframe_message', function() {
    window.location.href('https://pych-customers.web.app/AfterPaymentSaveTravel')
  }, false);

  return (
    <>
      <AccessibilityMenu />
      <Switch>
      <Route exact path='/' component={homePage}/>
      <Route exact path='/Collaboration' component={Collaboration}/>
      <Route exact path='/CollaborationNetivim' component={CollaborationNetivim}/>
      <Route exact path='/Agents' component={Agents}/>
      <Route exact path='/Profile' component={Profile}/>
      <Route exact path='/Terms' component={Terms}/>
      <Route exact path='/PrivacyStatement' component={PrivacyStatement}/>
      <Route exact path='/AccessibilityStatement' component={AccessibilityStatement}/>
      <Route exact path='/Invite' component={Invite}/>
      <Route exact path='/success' component={success}/>
      <Route exact path='/paymentErorr' component={paymentErorr}/>
      <Route exact path='/contact' component={contact}/>
      <Route exact path='/priceList' component={priceList}/>
      <Route exact path='/askOrbit' component={askOrbit}/>
      <Route exact path='/topBaner' component={topBaner}/>
      <Route exact path='/footer' component={footer}/>
      <Route exact path='/sideBar' component={sideBar}/>
      <Route exact path='/timeCalc' component={TimeCalc}/>
      <Route exact path='/myInvitation' component={myInvitation}/>
      <Route exact path='/notConfirmedYet' component={notConfirmedYet}/>
      <Route exact path='/mySadirTravels' component={mySadirTravels}/>
      <Route exact path='/comments' component={comments}/>
      <Route exact path='/editSadir' component={editSadir}/>
      <Route exact path='/editPrivate' component={editPrivate}/>
      <Route exact path='/afterPaymentSaveTravel' component={AfterPaymentSaveTravel}/>
      <Route exact path='/refund' component={refund}/>
      <Route exact path='/airports' component={airports}/>
      <Route exact path='/numOfPayment' component={numOfPayment}/>
      <Route exact path='/afterPayment' component={afterPayment}/>
      <Route exact path={`/byAgent/:id`} component={byAgent}/>
      <Route exact path={`/generateCard/:id/:date`} component={generateCard}/>
      <Route exact path={`/generateCard/:id`} component={generateCard}/>
      <Route path={`/verifyPassengers/:id/:type/:date`} component={verifyPassengers}/>
      <Route path={`/verifyInvite/:id/:type/:date`} component={verifyInvite}/>
      <Route path="/:id/:type/:date" component={invitationDetails} />
      <Route exact path="/payperclick" component={PayPerClick} />

    </Switch>
  </>
  )
}

export default App;
